(() => {
  const root = document.documentElement;
  const level = root.dataset.conpannaProtection;

  if (!level || level === 'off') return;

  const practicalContentSelector = [
    'input',
    'textarea',
    'select',
    '[contenteditable="true"]',
    '.product-info',
    '.product-gallery',
    '.shopify-policy__container',
    '.contact',
    '[data-copy-allowed]'
  ].join(',');

  const isPracticalContent = (node) => node instanceof Element && Boolean(node.closest(practicalContentSelector));

  document.addEventListener('dragstart', (event) => {
    if (event.target instanceof HTMLImageElement) event.preventDefault();
  });

  document.addEventListener('contextmenu', (event) => {
    if (event.target instanceof Element && event.target.closest('img, picture')) event.preventDefault();
  });

  if (level === 'editorial') {
    document.addEventListener('copy', (event) => {
      const selection = window.getSelection();
      const origin = selection && selection.anchorNode instanceof Element
        ? selection.anchorNode
        : selection && selection.anchorNode
          ? selection.anchorNode.parentElement
          : event.target;

      if (!isPracticalContent(origin)) event.preventDefault();
    });

    document.addEventListener('cut', (event) => {
      if (!isPracticalContent(event.target)) event.preventDefault();
    });
  }

  document.querySelectorAll('img').forEach((image) => image.setAttribute('draggable', 'false'));
})();
